import axios from 'axios';
const url = process.env.VUE_APP_BACKEND_URL
export default {
    async getPlans(week, year, hideHelperUsers = false) {
        const response = await axios.get(url + `get-plans/${week}/${year}/${hideHelperUsers}`)
        let data = response.data
        if (week === 53) {
            const response2 = await axios.get(url + `get-plans/${week}/${year+1}/${hideHelperUsers}`)
            data = [...data, ...response2.data]
        }
        return data
    },
    getPlansUser(upid, year) {
        return axios.get(url + `get-plans-user/${upid}/${year}`)
            .then(response => response.data)
    },
    getEmptyPlans(upid, week, year) {
        return axios.get(url + `get-empty-plans/${upid}/${week}/${year}`)
            .then(response => response.data)
    },
    submitPlan(planData) {
        return axios
            .post(url + 'plans/add/', planData)
            .then(response => response.data)
    }
};
